import { customerSelectorStyles } from "@insite/content-library/Components/CustomerSelector";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

const textStyles: TypographyPresentationProps = {
    color: "text.main",
};

Object.assign(customerSelectorStyles, {
    customerCard: {
        container: {
            gap: 10,
        },
        addressGridItem: {
            width: 6,
            css: css`
                padding: 1em;
            `,
        },
        actionsGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                padding: 1em;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["flex-start", "flex-end"], properties: ["justify-content"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        actionsWrapper: {
            css: css`
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["row", "column"], properties: ["flex-direction"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
    customerCardSelected: {
        container: {
            gap: 10,
            css: css`
                background-color: ${getColor("common.accent")};
            `,
        },
        addressGridItem: {
            width: 6,
            css: css`
                padding: 1em;
            `,
        },
        actionsGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                padding: 1em;
                justify-content: flex-end;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["flex-start", "flex-end"], properties: ["justify-content"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        actionsWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["row", "column"], properties: ["flex-direction"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
});
